(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("tone"));
	else if(typeof define === 'function' && define.amd)
		define(["tone"], factory);
	else if(typeof exports === 'object')
		exports["Piano"] = factory(require("tone"));
	else
		root["Piano"] = factory(root["tone"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition